import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Typography, Button, Box, Slide } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UpdateNotification() {

  const [show, setShow] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = e => {
      setRegistration(e.detail);   // aquí recibes el registration
      setShow(true);
    };
    window.addEventListener('swUpdated', handler);
    // ✅ Cuando el SW nuevo pasa a controlar la página, recarga
    const onControllerChange = () => {
      console.log('[SW] controllerchange -> recargando...');
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener('controllerchange', onControllerChange);
    // ✅ Alternativa/extra: si el SW manda mensaje “SW_ACTIVATED”, recarga
    const onMessage = (event) => {
      if (event.data?.type === 'SW_ACTIVATED') {
        console.log('[SW] SW_ACTIVATED -> recargando...');
        window.location.reload();
      }
    };
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('swUpdated', handler);
      navigator.serviceWorker?.removeEventListener('controllerchange', onControllerChange);
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      console.log('>> Enviando SKIP_WAITING');
      registration.waiting.postMessage('SKIP_WAITING');
    } else {
      // fallback: si por alguna razón no hay waiting, intenta recargar
      window.location.reload();
    }
  };

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 2,
          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
          color: '#fff',
          boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
          textAlign: 'center',
          maxWidth: 420
        }
      }}
    >
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, overflowY: 'hidden' }}>
        <Box
          sx={{
            background: 'rgba(255, 255, 255, 0.15)',
            borderRadius: '50%',
            p: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
            mb: 1,
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
          }}
        >
          <AutoAwesomeIcon sx={{ fontSize: 52, color: '#FFD700' }} />
        </Box>
        <Typography variant="h4" fontWeight="800" sx={{ color: '#fff', textShadow: '0 2px 4px rgba(0, 0, 0, 0.98)', fontFamily: "'Inter', sans-serif" }}>
          ¡Nueva versión disponible!
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.95, mb: 1, px: 1, fontSize: '1.05rem', lineHeight: 1.5 }}>
          Hemos agregado nuevas mejoras y optimizaciones. Actualiza ahora para disfrutar de la mejor experiencia del sistema.
        </Typography>
        <Button
          variant="contained"
          onClick={handleUpdate}
          startIcon={<SystemUpdateAltIcon />}
          sx={{
            mt: 1,
            background: '#FFD700',
            color: '#1e3c72',
            fontWeight: '900',
            fontSize: '1.1rem',
            px: 4,
            py: 1.5,
            borderRadius: 50,
            textTransform: 'none',
            boxShadow: '0 6px 15px rgba(255, 215, 0, 0.3)',
            '&:hover': {
              background: '#FFEA00',
              boxShadow: '0 8px 25px rgba(255, 215, 0, 0.6)',
              transform: 'translateY(-3px)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Actualizar Ahora
        </Button>
      </DialogContent>
    </Dialog>
  );
}
